import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { et3ParseInteger, getOnlyDigitsFromString } from "et3-type-guards";
import { MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED } from "../../../../constants/input-entries-constants";
import { USER_SEARCH_BY_ENTRIES } from "../../../../constants/picker-entries-constants";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";
import { E_USER_SEARCH_BY } from "../../../../Types";

const KhattabatAdvancedOptionFields = withLiteObserverAndTheme(() => {
  const {
    searchByInput,
    getInputPlaceholder,
    getSearchInputDisplayValue,
    changeSearchByInput,
    handleOnChooseInputAdvanced,
    getUserData
  } = getUserAdvancedStore();
  const searchBy = searchByInput.get();
  const isUserIdOption = searchBy === E_USER_SEARCH_BY.USER_ID;
  const isPhoneNumberOption = searchBy === E_USER_SEARCH_BY.PHONE_NUMBER;
  const isProfileIdOption = searchBy === E_USER_SEARCH_BY.PROFILE_ID;

  return (
    <Stack spacing={2}>
      <RadioGroup
        row
        value={searchBy}
        onChange={({ target }) => changeSearchByInput(target.value)}
      >
        {USER_SEARCH_BY_ENTRIES.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio size="small" />}
            label={option.label}
          />
        ))}
      </RadioGroup>
      <TextField
        size="small"
        label={getInputPlaceholder.get()}
        value={getSearchInputDisplayValue.get()}
        onChange={({ target }) => {
          if (!isUserIdOption) {
            handleOnChooseInputAdvanced(
              target.value,
              isPhoneNumberOption,
              isUserIdOption,
              isProfileIdOption
            );
            return;
          }
          const parsedStringValue = getOnlyDigitsFromString(target.value);
          if (parsedStringValue.length < MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED) {
            handleOnChooseInputAdvanced(
              et3ParseInteger(parsedStringValue),
              isPhoneNumberOption,
              isUserIdOption,
              isProfileIdOption
            );
          }
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            getUserData(true);
          }
        }}
        slotProps={{
          htmlInput: { inputMode: isUserIdOption ? "numeric" : "text" }
        }}
        sx={{ maxWidth: 360 }}
      />
    </Stack>
  );
});

export default KhattabatAdvancedOptionFields;
